import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import { deleteGroup } from '@/redux/actions';
import { updateGroup, addAttendeesToGroup, removeAttendeesFromGroup } from '@/redux/actions';
import { useParams } from 'react-router-dom';

const WS_GROUPS_BY_HTTP = {
	UPDATE_GROUP: 'groups/:groupID/PATCH',
	ADD_ATTENDEES: 'groups/:groupID/addAttendees/PATCH',
	REMOVE_ATTENDEES: 'groups/:groupID/removeAttendees/PATCH',
	DUPLICATE_GROUP: 'groups/:groupID/duplicate/PATCH',
	DELETE_GROUP: 'groups/:groupID/DELETE',
};

const GroupSubscriptions = props => {
	const {
		socket,
		children,
		deleteGroup,
		updateGroup,
		addAttendees,
		removeAttendees,
		route,
	} = props;
	const { id: groupID } = useParams();
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribeToGroup = () => {
		socket.emit('groups/:groupID/SUBSCRIBE', { groupID });
	};

	const unsubscribeToGroup = () => {
		socket.emit('groups/:groupID/UNSUBSCRIBE', { groupID });
	};

	const listedForUpdatedGroup = () => {
		socket.on(WS_GROUPS_BY_HTTP.UPDATE_GROUP, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Group could not be updated', error);
			else {
				const { name } = data;
				updateGroup(data);
				displayMessage(`${name} group updated`);
			}
		});
	};

	const listenForAddedAttendees = () => {
		socket.on(WS_GROUPS_BY_HTTP.ADD_ATTENDEES, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Accounts could not be added', error);
			else {
				addAttendees(data);
				displayMessage('Accounts added to group');
			}
		});
	};

	const listenForRemovedAttendees = () => {
		socket.on(WS_GROUPS_BY_HTTP.REMOVE_ATTENDEES, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Accounts could not be removed', error);
			else {
				removeAttendees(data);
				displayMessage('Accounts removed from group');
			}
		});
	};

	const listenForDuplicatedGroup = () => {
		socket.on(WS_GROUPS_BY_HTTP.DUPLICATE_GROUP, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error while duplicating group', error);
			else {
				const { name } = data;
				window.history.back();
				displayMessage(`${name} group duplicated`);
			}
		});
	};

	const listenForDeletedGroup = () => {
		socket.on(WS_GROUPS_BY_HTTP.DELETE_GROUP, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error while deleting group', error);
			else {
				const { deleteGroup: group, groupName } = data;
				deleteGroup(group.id);
				window.history.back();
				displayMessage(`${groupName} group deleted`);
			}
		});
	};

	const listeners = () =>
		route !== 'duplicate'
			? [
					listedForUpdatedGroup,
					listenForAddedAttendees,
					listenForRemovedAttendees,
					listenForDeletedGroup,
			  ]
			: [listenForDuplicatedGroup];
	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribeToGroup}
				unsub={unsubscribeToGroup}
				listeners={listeners()}
				routes={Object.values(WS_GROUPS_BY_HTTP)}
				from="GroupSubscriptions"
			/>
			{React.cloneElement(children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth, events }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	deleteGroup: groupID => dispatch(deleteGroup(groupID)),
	updateGroup: group => dispatch(updateGroup(group)),
	addAttendees: attendeeIDs => dispatch(addAttendeesToGroup(attendeeIDs)),
	removeAttendees: attendees => dispatch(removeAttendeesFromGroup(attendees)),
});

export default connect(msp, mdp)(GroupSubscriptions);
